var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 0.5H23.875C24.2083 0.5 24.375 0.666667 24.375 1V45C24.375 45.3333 24.2083 45.5 23.875 45.5H20.125C19.7917 45.5 19.625 45.3333 19.625 45V1C19.625 0.666667 19.7917 0.5 20.125 0.5Z",
    fill: "#686978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.625H43C43.3333 20.625 43.5 20.7917 43.5 21.125V24.875C43.5 25.2083 43.3333 25.375 43 25.375H1C0.666667 25.375 0.5 25.2083 0.5 24.875V21.125C0.5 20.7917 0.666667 20.625 1 20.625Z",
    fill: "#686978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridPlus);
export default __webpack_public_path__ + "static/media/gridPlus.42919ee9666f93770630b7d56f874a82.svg";
export { ForwardRef as ReactComponent };